<template>
    <section>
        <el-form class="form_cls" :inline="true" :model="filters" @submit.native.prevent>
            <el-form-item>
                <el-input style="width: 160px" v-model="filters.originalPositionCode" placeholder="原始岗位号"></el-input>
            </el-form-item>
            <el-form-item>
                <el-input style="width: 160px" v-model="filters.replacementPositionCode" placeholder="代岗岗位号"></el-input>
            </el-form-item>
            <el-form-item>
                <el-input style="width: 160px" v-model="filters.employeeName" placeholder="员工姓名"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" icon="el-icon-search" @click="getModules_search">查询</el-button>
                <el-button type="primary" icon="el-icon-plus" @click="handleAdd">新增</el-button>
            </el-form-item>
        </el-form>

        <!--列表-->
        <div class="table_top_div">
            <el-table border :max-height="tableHeight" :data="tabel_list" header-cell-class-name="header_cell_name"
                :cell-style="{ 'text-align': 'center' }" highlight-current-row
                :header-cell-style="{ 'text-align': 'center', color: '#6170d7', backgroundColor: '#F5F7FA', padding: ' 7px 0 !important' }"
                v-loading="listLoading" @selection-change="selsChange" style="width: 100%">
                <el-table-column prop="originalPositionCode" label="原始岗位号"></el-table-column>
                <el-table-column prop="originalEmployeeName" label="原员工姓名"></el-table-column>
                <el-table-column prop="replacementPositionCode" label="代岗岗位号"></el-table-column>
                <el-table-column prop="replacementEmployeeName" label="代岗员工姓名"></el-table-column>
                <el-table-column prop="isCancel" label="状态" width="100">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.isCancel ? 'danger' : 'success'">
                            {{ scope.row.isCancel ? '已停用' : '启用中' }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="updateTime" label="更新时间"></el-table-column>
                <el-table-column prop="createTime" label="创建时间"></el-table-column>
                <el-table-column label="操作" width="120">
                    <template slot-scope="scope">
                        <el-link type="primary" @click="handleEdit(scope.row)">
                            <i class="el-icon-edit"></i>
                            编辑
                        </el-link>
                    </template>
                </el-table-column>
            </el-table>

            <!--工具条-->
            <div class="toolbar_div" style="margin-top: 10px;">
                <el-col :span="24" class="toolbar">
                    <el-pagination :background="true" layout="prev, pager, next" @current-change="handleCurrentChange"
                        :page-size="50" :total="total" style="float: right"></el-pagination>
                </el-col>
            </div>
        </div>

        <!-- 新增/编辑 -->
        <el-dialog :title="title" :visible.sync="addFormVisible" :close-on-click-modal="false" width="500px">
            <el-form :model="addForm" label-width="120px" ref="addForm">
                <el-form-item label="原始岗位号" required>
                    <el-input :disabled="title == '编辑'" v-model="addForm.originalPositionCode"></el-input>
                </el-form-item>
                <el-form-item label="代岗岗位号" required>
                    <el-input v-model="addForm.replacementPositionCode"></el-input>
                </el-form-item>
                <el-form-item label="状态">
                    <el-radio-group v-model="addForm.isCancel">
                        <el-radio :label="false">启用</el-radio>
                        <el-radio :label="true">停用</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addFormVisible = false">关闭</el-button>
                <el-button type="primary" @click="sbumits">确定</el-button>
            </span>
        </el-dialog>
    </section>
</template>

<script>
import {
    getPositionReplacementList,
    createPositionReplacement,
    editPositionReplacement
} from '../../api/api'

export default {
    data() {
        return {
            addForm: {},
            addFormVisible: false,
            title: '',
            tableHeight: 0,
            currentRow: null,
            filters: {
                originalPositionCode: '',
                replacementPositionCode: '',
                employeeName: '',
                pageSize: 50
            },
            tabel_list: [],
            total: 0,
            page: 1,
            listLoading: false,
            sels: []
        }
    },
    methods: {
        async sbumits() {
            if (!this.addForm.originalPositionCode) {
                this.$message.error('请填写原始岗位号')
                return
            }
            if (!this.addForm.replacementPositionCode) {
                this.$message.error('请填写代岗岗位号')
                return
            }

            if (this.title == '新增') {
                var { data } = await createPositionReplacement(this.addForm)
            } else {
                var { data } = await editPositionReplacement({
                    id: this.addForm.id,
                    isCancel: this.addForm.isCancel,
                    replacementPositionCode:this.addForm.replacementPositionCode
                })
            }

            if (data.code == 200) {
                this.$message.success(data.msg)
                this.addFormVisible = false
                this.getModules_search()
            } else {
                this.$message.error(data.msg)
            }
        },
        handleAdd() {
            this.title = '新增'
            this.addForm = {}
            this.addFormVisible = true
        },
        handleEdit(row) {
            this.title = '编辑'
            this.addForm = {
                id: row.id,
                originalPositionCode: row.originalPositionCode,
                replacementPositionCode: row.replacementPositionCode,
                isCancel: row.isCancel
            }
            this.addFormVisible = true
        },
        getModules_search() {
            this.page = 1
            this.getModules()
        },
        async getModules() {
            let para = this.filters
            para.page = this.page
            this.listLoading = true
            getPositionReplacementList(para).then((res) => {
                this.total = res.data.dataCount
                this.tabel_list = res.data.data
                this.listLoading = false
            })
        },
        handleCurrentChange(val) {
            this.page = val
            this.getModules()
        },
        selsChange: function (sels) {
            this.sels = sels
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.tableHeight = window.innerHeight - 230
        })
        this.getModules()
    }
}
</script>

<style scoped></style>
